import React, { useState, useCallback, useEffect, } from "react";
import { v4 as uuidv4 } from "uuid";
import { Title } from "./Title";
import { Tooltip } from "./Tooltip";
import { Link } from "./Link";
import { setIcon } from "./utils/icons";
import { classNames } from "./utils/classNames";
import { THEME } from "./theming/theming";
import { useIconClasses } from "./theming/icons";
export const SubSection = ({ title, tooltip, open, children, titleLevel = "h3", display = "removed", arrowPosition = "right", id, hideBorderBottom = false, helpLink = undefined, warningMessage = undefined, }) => {
    const [show, setShow] = useState(!open ? "closed" : "open");
    const toggleOpen = useCallback(() => {
        if (show === "open") {
            setShow("closed");
        }
        else {
            setShow("opening");
        }
    }, [show, setShow]);
    useEffect(() => {
        if (show === "opening") {
            setTimeout(() => setShow("open"), 100);
        }
    }, [show]);
    const componentId = id || uuidv4();
    const borderClass = hideBorderBottom ? "no-border-bottom" : "";
    let { iconType, iconValue } = setIcon("exclamationSign");
    const iconClasses = useIconClasses(iconType, THEME.palette.warning.base.color);
    const subSectionTitle = (React.createElement(Title, { titleLevel: titleLevel, extraClass: titleLevel === "span" ? "sub-section-header--title" : "" }, title));
    const subSectionTitleWithToolTip = tooltip ? (React.createElement(Tooltip, { content: tooltip, tooltipId: uuidv4(), dataTestId: "iconTooltip" }, subSectionTitle)) : (subSectionTitle);
    const warning = warningMessage ? (React.createElement(React.Fragment, null,
        React.createElement("span", { className: classNames(iconClasses.icon, iconType, `${iconType}-${iconValue}`, "pl-5") }),
        warningMessage)) : null;
    const helpLinkElement = helpLink ? (React.createElement("div", { className: "float-right pr-2" },
        React.createElement(Link, { type: helpLink.type, label: helpLink.title, url: helpLink.url }))) : null;
    return (React.createElement("div", { className: "sub-section", id: componentId ? `${componentId}-sub-section` : undefined },
        open !== undefined && (React.createElement("div", { className: `sub-section-header ${borderClass}`, onClick: () => toggleOpen(), role: "button", onKeyPress: () => toggleOpen(), tabIndex: 0, "aria-expanded": show === "open", "aria-controls": componentId },
            open !== undefined && arrowPosition === "left" && (React.createElement("span", { className: `sub-section-header-indicator sub-section-header-indicator--left glyphicon glyphicon-chevron-right ${show}` })),
            subSectionTitleWithToolTip,
            warning,
            open !== undefined && arrowPosition === "right" && (React.createElement("span", { className: `sub-section-header-indicator sub-section-header-indicator--right glyphicon glyphicon-chevron-right ${show}` })),
            helpLinkElement)),
        open === undefined && (React.createElement("div", { className: `sub-section-header ${borderClass}` },
            subSectionTitleWithToolTip,
            warning,
            helpLinkElement)),
        React.createElement("div", { className: `sub-section--components ${show} ${open !== undefined ? `display-${display}` : ""}`, id: componentId },
            display === "removed" &&
                (show === "opening" || show === "open" || open === undefined) &&
                children,
            display === "hidden" && React.createElement("div", null, children))));
};
export const useSubSection = (open) => {
    const [show, setShow] = useState(open ? "closed" : undefined);
    const toggleOpen = useCallback(() => {
        if (show === "open") {
            setShow("closed");
        }
        else {
            setShow("opening");
        }
    }, [show, setShow]);
    useEffect(() => {
        if (show === "opening") {
            setTimeout(() => setShow("open"), 100);
        }
    }, [show]);
    return { show, toggleOpen };
};
